import { AboutYourLoan } from "domain/aboutYourLoan";
import {
  defaultExistingLoanDetails,
  ExistingLoanDetails,
  IndicativeRepaymentOptions,
  RepaymentOption,
} from "domain/indicativeRepaymentOptions";
import { action, computed } from "mobx";
import { postCalculateIndicativeRepaymentOptions } from "services/indicativeRepaymentOptions";
import { StoreBase } from "./storeBase";

export class IndicativeRepaymentOptionsStore extends StoreBase<IndicativeRepaymentOptions> {
  constructor() {
    super(() => null);
  }

  @computed
  get repaymentOptions(): RepaymentOption[] {
    return this.data?.repaymentOptions || [];
  }

  @computed
  get existingLoanDetails(): ExistingLoanDetails {
    return this.data?.existingLoanDetails || defaultExistingLoanDetails();
  }

  @computed
  get hasInvalidNumberOfRepayments(): boolean {
    return (this.data?.existingLoanDetails?.numberOfRepayments ?? 0) <= 0;
  }

  @action
  postIndicativeRepaymentOptions = async (aboutYourLoan: AboutYourLoan) => {
    return this.updateData(() =>
      postCalculateIndicativeRepaymentOptions(aboutYourLoan)
    );
  };
}
